module.exports = __webpack_public_path__ + "img/faultIcon.42fd9154.svg";